import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header-content" }
const _hoisted_2 = { class: "left-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "h-shape" }, null, -1)
const _hoisted_4 = { class: "image" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "right-header" }
const _hoisted_7 = ["dir"]
const _hoisted_8 = ["dir"]

import MyPicture from '@/assets/img/me.jpg'
import CV from '@/components/DownloadCV.vue'
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

const { locale } = useI18n();


const isRTL = computed(() => {
  return locale.value === 'ar'; // 'ar' is the code for Arabic
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("img", {
          src: _unref(MyPicture),
          alt: ""
        }, null, 8, _hoisted_5)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("h1", {
        class: "name",
        dir: isRTL.value ? 'rtl' : 'ltr'
      }, [
        _createTextVNode(_toDisplayString(_ctx.$t('greeting')) + " ", 1),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('myname')) + ".", 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('jobtitle')), 1)
      ], 8, _hoisted_7),
      _createElementVNode("p", {
        dir: isRTL.value ? 'rtl' : 'ltr'
      }, _toDisplayString(_ctx.$t('description')), 9, _hoisted_8),
      _createVNode(CV)
    ])
  ]))
}
}

})